import React, { useState } from "react";
import { Button, Typography, Modal } from "../../../core";
import { theme } from "../../../styles";
import YarnReceivedModal from "./yarnReceivedModal";
import YarnReturnModal from "./yarnReturnModal";

const { textColor, buttonBg } = theme;
const ButtonProps = {
  bg: buttonBg.primary,
};
const TypoProps = {
  as: "h3",
  weight: "bold",
  color: "white",
  align: "center",
};

const ClothReturnModalCompo = ({
  getYarnDetails,
  contractDetails,
  yarnIssuenceModal,
  closeModal,
}) => {
  const [modalState, setModalState] = useState({
    yarnReceivedModal: false,
    yarnReturnModal: false,
  });

  const closeModalHandler = (name) => {
    setModalState((prev) => ({
      ...prev,
      [name]: false,
    }));
  };

  const openModal = (name) => {
    setModalState((prev) => ({
      ...prev,
      [name]: true,
    }));
  };

  return (
    <React.Fragment>
      <Modal
        closable={true}
        visible={yarnIssuenceModal}
        okText="Add"
        maxwidth="568px"
        footer={false}
        onCancel={() => {
          closeModal("yarnIssuenceModal");
          getYarnDetails();
        }}
        tittle="Yarn Issuence"
      >
        <Button className="btn-w--187" {...ButtonProps}>
          <Typography
            {...TypoProps}
            text="Receive"
            onClick={() => openModal("yarnReceivedModal")}
          />
        </Button>
        <Typography {...TypoProps} text="Or" color={textColor.primary} />
        <Button className="btn-w--187" {...ButtonProps}>
          <Typography
            {...TypoProps}
            text="Return"
            onClick={() => openModal("yarnReturnModal")}
          />
        </Button>
      </Modal>

      {modalState.yarnReceivedModal && (
        <YarnReceivedModal
          contractDetails={contractDetails}
          yarnReceivedModal={modalState.yarnReceivedModal}
          closeModalHandler={closeModalHandler}
        />
      )}
      {modalState.yarnReturnModal && (
        <YarnReturnModal
          contractDetails={contractDetails}
          yarnReturnModal={modalState.yarnReturnModal}
          closeModalHandler={closeModalHandler}
        />
      )}
    </React.Fragment>
  );
};

export default ClothReturnModalCompo;
